// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

// components
import NotificationPortal from "./Portal";

// actions
import { CleanNotifications, DisplayUndo } from "../../actions/notifications.actions";

import PropTypes from "../../lib/prop-types";

import ToastNotification from "./notification/toast";
import UndoNotification from "./notification/undo";

class Notifications extends React.Component {
	static propTypes = {
		removeNotification: PropTypes.func.isRequired,
		notifications: PropTypes.instanceOf(List).isRequired,
	};

	componentDidMount() {}

	removeNotification = (notificationID) => {
		this.props.removeNotification(notificationID);
	};

	render() {
		const { notifications } = this.props;

		const items = notifications.map((notification, i) => {
			let component;
			const height = (1 + Math.floor(notification.get("message").length / 36)) * 20 + 20;

			switch (notification.get("type")) {
				case "undo":
					component = (
						<UndoNotification
							key={notification.get("id")}
							undoCallback={notification.get("callback")}
							message={notification.get("message")}
							style={{ bottom: (height + 5) * i }}
						/>
					);
					break;

				case "toast": {
					const notificationID = notification.get("id");
					component = (
						<ToastNotification
							key={notificationID}
							message={notification.get("message")}
							action={notification.get("clickAction")}
							remove={() => this.removeNotification(notificationID)}
							style={{ bottom: (height + 5) * i }}
						/>
					);
					break;
				}

				default:
					component = <div />;
			}

			return component;
		});

		return <NotificationPortal>{items}</NotificationPortal>;
	}
}

const mapStateToProps = (state) => ({
	notifications: state.notifications.get("active", List()),
});

const mapDispatchToProps = (dispatch) => ({
	removeNotification: (notificationID) => dispatch(CleanNotifications(notificationID)),
	displayUndo: (message, undoAction) => dispatch(DisplayUndo(message, undoAction)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Notifications);
